<template>

  <b-form-group
    :label="label"
    :label-for="id"
    class="bold-label mb-4"
    :state="address.state"
    :invalid-feedback="address.invalidFeedback">
    <div v-if="info">{{info}}</div>
    <GmapAutocomplete
      :id="id"
      class="form-control"
      v-model="address.value"
      :state="address.state"
      :placeholder="placeholder"
      :required="isRequired"
      @input="handleAddressInput"
      @place_changed="setAddress"
      @focusout="handleFocusOut"
      @keydown.enter.prevent>
    </GmapAutocomplete>
    <b-form-text>{{helpMessage}}</b-form-text>
  </b-form-group>

</template>

<script>
export default {
  name: 'MapAutocompleteField',

  props: {
    address: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: 'input'
    },
    placeholder: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: null
    },
    helpMessage: {
      type: String,
      default: null
    }
  },

  methods: {

    removeInvalidFeedback () {
      this.address.state = null
      this.address.invalidFeedback = null
    },

    handleAddressInput(value) {
      if (value instanceof InputEvent) {
        this.address.value = value.target.value;
      } else {
        this.address.value = value;
      }
      this.address.latitude = null
      this.address.longitude = null
      this.address.city = null
      this.address.department = null
    },

    setAddress(place) {
      if (place.formatted_address) {
        this.address.value = place.formatted_address
        this.address.latitude = place.geometry ? place.geometry.location.lat() : null
        this.address.longitude = place.geometry ? place.geometry.location.lng() : null
        if (place.address_components) {
          place.address_components.forEach(placeComponent => {
            if (placeComponent.types.includes('locality')) {
              this.address.city = placeComponent.long_name
            }
            else if (placeComponent.types.includes('administrative_area_level_2')) {
              this.address.department = placeComponent.long_name
            }
          })
        }
        if (this.address.latitude && this.address.longitude) {
          this.removeInvalidFeedback()
        }
      } else if (place.name === '') {
        this.removeInvalidFeedback()
      }
      else {
        this.address.state = false
        this.address.invalidFeedback = this.$i18n.t('address.error')
      }
    },

    handleFocusOut(value) {
      if (value.target.value !== '' && (this.address.latitude == null || this.address.longitude == null)) {
        this.address.state = false
        this.address.invalidFeedback = this.$i18n.t('address.error')
      }
      else {
        this.removeInvalidFeedback()
      }
    }

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/MapAutocompleteField.vue